import React, { useState, useContext, useEffect } from "react";
import { Row, Col, FormGroup, Label, Form, Progress } from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";
import validator from "validator";
import "react-toastify/dist/ReactToastify.css";
import { UserContext } from "../../../context/UserContext";
import { Redirect } from "react-router";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../../css/myprofile.css";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import GetAppIcon from "@material-ui/icons/GetApp";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Card, FormControl, InputLabel } from "@material-ui/core";
import { CardBody, CardHeader } from "reactstrap";

import Paper from "@material-ui/core/Paper";
import StopIcon from "@material-ui/icons/Stop";
//import { green } from "@material-ui/core/colors";
// import { deepMerge } from "grommet/utils";
// import { grommet } from "grommet";
import Select from "@material-ui/core/Select";
//import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import MaterialComponent from "../LearnerAssesment/MaterialComponent";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import MaterialTable from "material-table";
import EditIcon from "@material-ui/icons/Edit";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

// const myTheme = deepMerge(grommet, {
//   tabs: {
//     header: {
//       border: {
//         side: "bottom",
//         color: "blue",
//         size: "small",
//       },
//     },
//   },
//   tab: {
//     border: {
//       side: "bottom",
//       color: "dark-4",
//     },
//     pad: "small",
//     margin: {
//       // bring the overall tabs border behind invidual tab borders
//       vertical: "-2px",
//       horizontal: "none",
//     },
//   },
// });
const Uploaddocument = () => {
  const context = useContext(UserContext);
  const [experiencelist, setExperiencelist] = useState([]);
  const [academicslist, setAcademicslist] = useState([]);
  const [genderlist, setGenderlist] = useState([]);
  const [countrylist, setCountrylist] = useState([]);
  const [degreelist, setDegreelist] = useState([]);
  const [gradelist, setGradelist] = useState([]);
  const [completerate, setCompleterate] = useState("");

  const [peravtarpath, setPeravtarpath] = useState(null);
  const [gendertype, setGendertype] = useState("");

  const [emergency_contact_name, setEmergencycontactname] = useState("");
  const [emergency_contact_number, setEmergencycontactnumber] = useState("");
  const [emergency_contact_email, setEmergencycontactemail] = useState("");
  const [peraddress, setPraddress] = useState("");
  const [perpin, setPerpin] = useState("");
  const [percountryname, setPercountryname] = useState("");
  const [localaddress, setLocaladdress] = useState("");
  const [localpin, setLocalpin] = useState("");
  const [localcountryname, setLocalcountryname] = useState("");

  const [issameaddress, setIssameaddress] = useState(false);
  const [value, setValue] = useState(0);
  const [myview, setmyview] = useState("personal-details");
  const [loading, setLoading] = useState(false);

  const [firstName, setFirstname] = useState("");
  const [middleName, setMiddlename] = useState("");
  const [lastName, setLastname] = useState("");
  const [dateofbirth, setDateofbirth] = useState("");
  const [gender, setGender] = useState("");
  const [learneremail, setEmail] = useState("");
  const [mobileno, setMobileno] = useState("");

  const [degree, setDegree] = useState("");
  const [qualificationname, setQualificationname] = useState("");
  const [university, setUniversity] = useState("");
  const [institute, setInstitute] = useState("");
  const [percentage, setPercentage] = useState("");
  const [grademark, setGrademark] = useState("");
  const [passingyear, setPassingyear] = useState("");
  const [isdegreecompleted, setIsdegreecompleted] = useState("");
  const [eduFilename, setSelectedEduFile] = useState(null);

  const [iscurrentlyWorking, setIscurrentlyWorking] = useState(false);
  const [organizationname, setOrganizationname] = useState("");
  const [designation, setDesignation] = useState("");
  const [domain, setDomain] = useState("");
  const [startdate, setStartdate] = useState("");
  const [endtdate, setEndtdate] = useState("");

  const [modalIsOpenedu, setIodalIsOpenedu] = useState(false);
  const [modalIsOpen, setIodalIsOpen] = useState(false);
  const [modalIsOpenedit, setIsOpenedit] = useState(false);
  const [academicfile, setAcademicfile] = useState(null);

  const [organizationnameedit, setOrganizationnameedit] = useState("");
  const [designationedit, setDesignationedit] = useState("");
  const [domainedit, setDomainedit] = useState("");
  const [startdateedit, setStartdateedit] = useState("");
  const [enddateedit, setEnddateedit] = useState("");
  const [iscurrentlyworkingedit, setIscurrentlyworkingedit] = useState(false);
  const [expid, setExpid] = useState("");
  const [academicid, setAcademicid] = useState("");
  
  const [avtarFilename, setAvtarFilename] = useState(null);

  const [degreenameedit, setDegreenameedit] = useState("");
  const [nameofqualificationedit, setNameofqualificationedit] = useState("");
  const [cpimarksedit, setCpimarksedit] = useState("");
  const [universityedit, setUniversityedit] = useState("");
  const [institutenameedit, setInstitutenameedit] = useState("");
  const [gradeclassnameedit, setGradeclassnameedit] = useState("");
  const [academicsdocpathedit, setAcademicsdocpathedit] = useState("");
  const [isdegreecompletededit, setIsdegreecompletededit] = useState(false);
  const [yearofpassingedit, setYearofpassingedit] = useState("");
  


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    // Update the document title using the browser API
    getuploaddoc();
  }, []);
  const getuploaddoc = async () => {
    axios
      .post("LearnerProfile/uploaddocumentform")
      .then((res) => {
        if (res.data.status === "200") {
          //setUploaddocData(res.data.uploaddocData);
          setGenderlist(res.data.genderlist);
          setAcademicslist(res.data.academicslist);
          setGradelist(res.data.gradelist);
          setDegreelist(res.data.degreelist);
          setCountrylist(res.data.countrylist);
        
          setExperiencelist(res.data.experiencelist);

          setFirstname(res.data.firstName);
          setMiddlename(res.data.middleName);
          setLastname(res.data.lastName);
          setDateofbirth(res.data.dateofbirth);
          setGender(res.data.gendertype);
          setEmail(res.data.learneremail);
          setMobileno(res.data.learnermob);
          setCompleterate(res.data.completerate);

          setPeravtarpath(res.data.peravtarpath);
          setGendertype(res.data.gendertype);

          setEmergencycontactname(res.data.emergency_contact_name);
          setEmergencycontactnumber(res.data.emergency_contact_number);
          setEmergencycontactemail(res.data.emergency_contact_email);
          setPraddress(res.data.peraddress);
          setPerpin(res.data.perpin);
          setPercountryname(res.data.percountryname);
          setLocaladdress(res.data.localaddress);
          setLocalpin(res.data.localpin);
          setLocalcountryname(res.data.localcountryname);

          //  console.log("mobileno =="+ mobileno);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };
  const handlerSubmit1 = (e) => {
    e.preventDefault();
    savepersondetails();
  };

  const savepersondetails = async () => {
    setLoading(true);
    // var checkurl = false;
    // console.log("lastName   == " + lastName);
    if (!Number(mobileno)) {
      toast.error("Please enter valid Phone no  ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (mobileno && (mobileno.length < 6 || mobileno.length > 12)) {
      toast.error("Please enter valid Phone no , without prefix ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (!validator.isEmail(learneremail) && learneremail) {
      toast.error("Please enter valid email");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (firstName && !firstName.match(/^[a-zA-Z]+$/)) {
      toast.error(" Please enter valid first Name ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (lastName && !lastName.match(/^[a-zA-Z]+$/)) {
      toast.error(" Please enter valid last Name ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (middleName && !middleName.match(/^[a-zA-Z]+$/)) {
      toast.error(" Please enter valid last Name ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (gender == null && !gender) {
      toast.error(" Please Select Gender ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (!dateofbirth && dateofbirth == null) {
      toast.error(" Please enter date of birth ");
      await sleep(3000);
      setLoading(false);
      return;
    } else {
      var formData = new FormData();
      formData.append("firstname", firstName);
      formData.append("middlename", middleName);
      formData.append("learneremail", learneremail);
      formData.append("mobileno", mobileno);
      formData.append("gender", gender);
      formData.append("lastname", lastName);
      formData.append("dateofbirth", dateofbirth);

      await axios
        .post("LearnerProfile/savepersondetailsdoc", formData)

        .then((res) => {
          // console.log("res  ====");
          if (res.data.status === "200" || res.data.status === "100") {
            toast.success(res.data.msg);
            // console.log("Saved Successfully");
            //window.location.reload(true);
            setCompleterate(res.data.completerate);

            setFirstname(res.data.firstName);
            setMiddlename(res.data.middleName);
            setLastname(res.data.lastName);
            setDateofbirth(res.data.dateofbirth);
            setGender(res.data.gendertype);
            setEmail(res.data.learneremail);
            setMobileno(res.data.learnermob);
            setGenderlist(res.data.genderlist);
            //setmyview("contact-details")
            setLoading(false);
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  };

  const handlerSubmit2 = (e) => {
    e.preventDefault();
    savecontactdetails();
  };

  const savecontactdetails = async () => {
    setLoading(true);
    // var checkurl = false;

    if (!peraddress && peraddress == null) {
      toast.error("Please Enter Permanent Address  ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (!perpin && perpin == null) {
      toast.error("Please enter Permanent PinCode/Zip Code ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (!percountryname && percountryname == null) {
      toast.error("Please Select Permanent Country");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (localaddress == null && !localaddress) {
      toast.error(" Please Enter Local Address ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (localpin == null && !localpin) {
      toast.error(" Please Enter Current PinCode/Zip Code ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (localcountryname == null && !localcountryname) {
      toast.error(" Please Select Current  Country ");
      await sleep(3000);
      setLoading(false);
      return;
    } else {
      var formData = new FormData();
      formData.append("peraddress", peraddress);
      formData.append("perpin", perpin);
      formData.append("percountryname", percountryname);
      formData.append("localaddress", localaddress);
      formData.append("localpin", localpin);
      formData.append("localcountryname", localcountryname);
      formData.append("emergency_contact_name", emergency_contact_name);
      formData.append("emergency_contact_number", emergency_contact_number);
      formData.append("emergency_contact_email", emergency_contact_email);

      await axios
        .post("LearnerProfile/savecontactdetailsdoc", formData)

        .then((res) => {
          // console.log("res  ====");
          if (res.data.status === "200" || res.data.status === "100") {
            toast.success(res.data.msg);
            // console.log("Saved Successfully");
            setCountrylist(res.data.countrylist);
            setEmergencycontactname(res.data.emergency_contact_name);
            setEmergencycontactnumber(res.data.emergency_contact_number);
            setEmergencycontactemail(res.data.emergency_contact_email);
            setPraddress(res.data.peraddress);
            setPerpin(res.data.perpin);
            setPercountryname(res.data.percountryname);
            setLocaladdress(res.data.localaddress);
            setLocalpin(res.data.localpin);
            setLocalcountryname(res.data.localcountryname);
            //setmyview("educational-details")
            setLoading(false);
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  };

  const handlerSubmit3 = (e) => {
    e.preventDefault();
    saveeducationdetails();
  };

  const saveeducationdetails = async () => {
    setLoading(true);
    // var checkurl = false;
    if (eduFilename) {
      let filename = eduFilename.name.split(".").pop();
      if (
        filename !== "pdf" &&
        filename !== "jpg" &&
        filename !== "xls" &&
        filename !== "jpeg" &&
        filename !== "xlsx" &&
        filename !== "docx" &&
        filename !== "doc" &&
        filename !== "txt"
      ) {
        // console.log("upload only" + filename);
        toast.error(" upload only pdf/jpg/jpeg/docx/txt/xlsx files");
        await sleep(3000);
        setLoading(false);
        return;
      }
    }
    // console.log(" qualificationname  =" +qualificationname)
    if (!degree || degree === null || degree === "") {
      toast.error("Please Select Degree  ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (!qualificationname || qualificationname === null ||qualificationname === "") {
      toast.error("Please Enter Name Of Qualification ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (!university || university === null || university === "") {
      toast.error("Please Enter university");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (institute === null || !institute || institute === "") {
      toast.error(" Please Enter Institute ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (percentage === null || !percentage || percentage === "") {
      toast.error(" Please Enter Percentage/CPI ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (grademark === null || !grademark || grademark ==="") {
      toast.error(" Please Select Class Obtain ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (passingyear === null || !passingyear || passingyear ==="") {
      toast.error(" Please Enter Year Of Passing ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (isdegreecompleted === null|| !isdegreecompleted || isdegreecompleted ==="") {
      toast.error(" Please Select Is Degree Completed ");
      await sleep(3000);
      setLoading(false);
      return;
    } else {
      var formData = new FormData();
      formData.append("degree", degree);
      formData.append("qualificationname", qualificationname);
      formData.append("university", university);
      formData.append("institute", institute);
      formData.append("percentage", percentage);
      formData.append("grademark", grademark);
      formData.append("passingyear", passingyear);
      formData.append("isdegreecompleted", isdegreecompleted);
      formData.append("eduFilename", eduFilename);
      await axios
        .post("LearnerProfile/saveceducationdetailsdoc", formData)

        .then((res) => {
          // console.log("res  ====");
          if (res.data.status === "200" || res.data.status === "100") {
            toast.success(res.data.msg);
            // console.log("Saved Successfully");
            setAcademicslist(res.data.academicslist);
            setDegreelist(res.data.degreelist);
            setGradelist(res.data.gradelist);
            setLoading(false);
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  };

  const handlerSubmit4 = (e) => {
    e.preventDefault();
    saveexperiencetails();
  };

  const saveexperiencetails = async () => {
    setLoading(true);
    // var checkurl = false;
    // console.log("lastName   == " + lastName);
    if (!organizationname && organizationname === null ) {
      toast.error("Please enter Organization Name  ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (designation === null && !designation) {
      toast.error(" Please enter Designation ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (domain === null && !domain) {
      toast.error(" Please enter Domain ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (startdate === null && !startdate) {
      toast.error(" Please enter From Date ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (endtdate === null && endtdate) {
      toast.error(" Please enter To Date ");
      await sleep(3000);
      setLoading(false);
      return;
    } else {
      var formData = new FormData();
      formData.append("organizationname", organizationname);
      formData.append("designation", designation);
      formData.append("domain", domain);
      formData.append("startdate", startdate);
      formData.append("endtdate", endtdate);

      await axios
        .post("LearnerProfile/savecexperiencedetailsdoc", formData)

        .then((res) => {
          // console.log("res  ====");
          if (res.data.status === "200" || res.data.status === "100") {
            toast.success(res.data.msg);
            // console.log("Saved Successfully");
            setExperiencelist(res.data.experiencelist);
            setLoading(false);
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  };

  const openModaledu = (e, academicfilepath) => {
    // console.log("academicfilepath    ===" + academicfilepath);
    setIodalIsOpenedu(true);
    setAcademicfile(academicfilepath);
  };
  const closeModaledu = (e) => {
    setIodalIsOpenedu(false);
  };

  
  const openModaledit = (e, academicid) => {
   // console.log("eduid    ===" + eduid);
    setIsOpenedit(true);
    setAcademicid(academicid);
   
    updateacademics(academicid);
  };
  const closeModaledit = (e) => {
    setIsOpenedit(false);
  };
  const updateacademics = async (academicid) => {
    var formData = new FormData();
    formData.append("academicid", academicid);
    axios
      .post("LearnerProfile/editacademicdetailsdoc", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          setGradelist(res.data.gradelist);
          setDegreelist(res.data.degreelist);
          setDegreenameedit(res.data.degreenameedit);
          setNameofqualificationedit(res.data.nameofqualificationedit);
          setCpimarksedit(res.data.cpimarksedit);
          setUniversityedit(res.data.universityedit);
          setInstitutenameedit(res.data.institutenameedit);
          setGradeclassnameedit(res.data.gradeclassnameedit);
          //setAcademicsdocpathedit(res.data.academicsdocpathedit);
          setIsdegreecompletededit(res.data.isdegreecompletededit);
        
          setYearofpassingedit(res.data.yearofpassingedit);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };


  const openModal = (e, expid) => {
    setIodalIsOpen(true);
    setExpid(expid);
    updateexp(expid);
  };
  const closeModal = (e, expid) => {
    setIodalIsOpen(false);
  };

  const updateexp = async (expid) => {
    var formData = new FormData();
    formData.append("expid", expid);
    axios
      .post("LearnerProfile/editexperiencedetailsdoc", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          setOrganizationnameedit(res.data.organizationnameedit);
          setDesignationedit(res.data.designationedit);
          setDomainedit(res.data.domainedit);
          setStartdateedit(res.data.startdateedit);
          setEnddateedit(res.data.enddateedit);
          setIscurrentlyworkingedit(res.data.iscurrentlyworkingedit);
          // scrollToRef(myRef);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };

  const handlerSubmiteditexp = (e) => {
    e.preventDefault();
    saveupdateexp();
  };

  const saveupdateexp = async () => {
    setLoading(true);
    // var checkurl = false;
    // console.log("lastName   == " + lastName);
    if (!organizationnameedit && organizationnameedit === null) {
      toast.error("Please enter Organization Name  ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (designationedit === null && !designationedit) {
      toast.error(" Please enter Designation ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (domainedit === null && !domainedit) {
      toast.error(" Please enter Domain ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (startdateedit == null && !startdateedit) {
      toast.error(" Please enter From Date ");
      await sleep(3000);
      setLoading(false);
      return;
    } else {
      var formData = new FormData();
      formData.append("organizationnameedit", organizationnameedit);
      formData.append("designationedit", designationedit);
      formData.append("domainedit", domainedit);
      formData.append("startdateedit", startdateedit);

      if (iscurrentlyworkingedit === true) {
        formData.append("enddateedit", "");
      } else {
        formData.append("enddateedit", enddateedit);
      }

      formData.append("expid", expid);

      await axios
        .post("LearnerProfile/saveeditexperiencedetailsdoc", formData)

        .then((res) => {
          // console.log("res  ====");
          if (res.data.status === "200" || res.data.status === "100") {
            toast.success(res.data.msg);
            setIodalIsOpen(false);
            setExperiencelist(res.data.experiencelist);
            setLoading(false);
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  };

  const handlerSubmit5 = (e) => {
    e.preventDefault();
    saveavtarFile();
  };

  const saveavtarFile = async () => {
    setLoading(true);
    // var checkurl = false;
    if (avtarFilename) {
      let filename = avtarFilename.name.split(".").pop();
      if (filename !== "jpg" && filename !== "jpeg") {
        // console.log("upload only" + filename);
        toast.error(" upload only jpg/jpeg files");
        await sleep(3000);
        setLoading(false);
        return;
      }
    }

    if (avtarFilename === null && !avtarFilename) {
      toast.error(" upload only pdf/jpg/jpeg/docx/txt/xlsx files");
      await sleep(3000);
      setLoading(false);
      return;
    } else {
      var formData = new FormData();

      formData.append("avtarFilename", avtarFilename);
      await axios
        .post("LearnerProfile/saveavtarFilenamedoc", formData)

        .then((res) => {
          // console.log("res  ====");
          if (res.data.status === "200" || res.data.status === "100") {
            toast.success(res.data.msg);
            // console.log("Saved Successfully");

            setPeravtarpath(res.data.peravtarpath);
            setLoading(false);
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  };

  if (!context.user?.email) {
    return <Redirect to="/" />;
  }

  
  const handlerSubmiteditacadmic = (e) => {
    e.preventDefault();
    saveupdatacadmic();
  };

  const saveupdatacadmic = async () => {
    setLoading(true);
    if (academicsdocpathedit) {
      let filename = academicsdocpathedit.name.split(".").pop();
      if (
        filename !== "pdf" &&
        filename !== "jpg" &&
        filename !== "xls" &&
        filename !== "jpeg" &&
        filename !== "xlsx" &&
        filename !== "docx" &&
        filename !== "doc" &&
        filename !== "txt"
      ) {
        // console.log("upload only" + filename);
        toast.error(" upload only pdf/jpg/jpeg/docx/txt/xlsx files");
        await sleep(3000);
        setLoading(false);
        return;
      }
    }


    if (!nameofqualificationedit || nameofqualificationedit === null || nameofqualificationedit ==="") {
      toast.error("Please enter Name of Qualification   ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (degreenameedit === null ||  !degreenameedit || degreenameedit ==="") {
      toast.error(" Please Select Degree ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (cpimarksedit === null ||  !cpimarksedit || cpimarksedit === "") {
      toast.error(" Please Enter Percentage/CPI ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (universityedit === null || !universityedit || universityedit ==="") {
      toast.error(" Please Enter university ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (institutenameedit === null ||  !institutenameedit || institutenameedit ==="") {
      toast.error("  Please Enter Institute ");
      await sleep(3000);
      setLoading(false);
      return;
    } 
    else if (gradeclassnameedit === null ||  !gradeclassnameedit || gradeclassnameedit === "") {
      toast.error("Please Select Class Obtain ");
      await sleep(3000);
      setLoading(false);
      return;
    } 
    else if (isdegreecompletededit === null ||!isdegreecompletededit  || isdegreecompletededit ==="") {
      toast.error("Please Select Is Degree Completed ");
      await sleep(3000);
      setLoading(false);
      return;
    } 
    // else if (universityedit == null && !universityedit) {
    //   toast.error(" Please enter From Date ");
    //   await sleep(3000);
    //   setLoading(false);
    //   return;
    // } 
    else {
      var formData = new FormData();
      formData.append("academicsdocpathedit", academicsdocpathedit);
      formData.append("degreenameedit", degreenameedit);
      formData.append("nameofqualificationedit", nameofqualificationedit);
      formData.append("cpimarksedit", cpimarksedit);
      formData.append("gradeclassnameedit", gradeclassnameedit);
      formData.append("isdegreecompletededit", isdegreecompletededit);
       formData.append("universityedit", universityedit);
      formData.append("institutenameedit", institutenameedit);
      formData.append("academicid", academicid);
      formData.append("yearofpassingedit", yearofpassingedit);

      await axios
        .post("LearnerProfile/saveeditacademicdetailsdoc", formData)

        .then((res) => {
          // console.log("res  ====");
          if (res.data.status === "200" || res.data.status === "100") {
            toast.success(res.data.msg);
            setIsOpenedit(false);
            setAcademicslist(res.data.academicslist);
            setDegreelist(res.data.degreelist);
            setGradelist(res.data.gradelist);
            setLoading(false);
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  };


  return (
    <div>
      <section class="padding-default2">
        <div class="panel panel-primary card">
          <div class="panel-heading">Documents </div>

          <div class="padding-pannele">
            <div class="row ">
              <div class="col-md-12">
                <Container fixed>
                  <Typography
                    component="div"
                    style={{
                      backgroundColor: "#dfe9f0",
                      paddingTop: "1%",
                      paddingBottom: "3%",
                      paddingRight: "10px",
                      paddingLeft: "10px",
                    }}
                  >
                    <span class="per-completed" style={{ marginLeft: "10px" }}>
                      {" "}
                      {completerate} % Completed
                    </span>

                    <Progress animated color="#e0b57d" value={completerate}>
                      {completerate} %
                    </Progress>
                  </Typography>
                </Container>
              </div>
            </div>
            <br />
            <Row>
              <Col sm={12}>
                <StopIcon style={{ color: "#7bfa7b" }} /> Completed &nbsp;&nbsp;
                <StopIcon style={{ color: "#f37340" }} /> Compulsory & Incomplete
                &nbsp;&nbsp;
                <StopIcon style={{ color: "#56c2f5" }} /> Optional &
                Incomplete
              </Col>
            </Row>{" "}
            <br />
            <Row>
              <Col sm={12}>
                <Card>
                  <CardHeader>
                    <div>
                      <Paper square="false">
                        <Tabs
                          value={value}
                          onChange={handleChange}
                          // aria-label="full width tabs example"

                          aria-label="scrollable force tabs example"
                          centered
                        >
                          <Tab
                            label="Personal Details "
                            onClick={(e) => setmyview("personal-details")}
                            style={{
                              backgroundColor:
                                dateofbirth != null ? "#7bfa7b" : "#f37340",
                            }}
                          />
                          <Tab
                            label="Contact Details "
                            onClick={(e) => setmyview("contact-details")}
                            style={{
                              backgroundColor:
                                peraddress !== null && peraddress !== ""
                                  ? "#7bfa7b"
                                  : "#f37340",
                            }}
                          />
                          <Tab
                            label="Educational Details"
                            onClick={(e) => setmyview("educational-details")}
                            style={{
                              backgroundColor:
                                academicslist.length > 0 ? "#7bfa7b" : "#f37340",
                            }}
                          />
                          <Tab
                            label="Experience Details "
                            onClick={(e) => setmyview("experience-details")}
                            style={{
                              backgroundColor: "#56c2f5",
                            }}
                          />
                          <Tab
                            label="Photo upload "
                            onClick={(e) => setmyview("photo-upload")}
                            style={{
                              backgroundColor:
                                peravtarpath != null ? "#7bfa7b" : "#f37340",
                            }}
                          />
                        </Tabs>
                      </Paper>
                    </div>
                  </CardHeader>
                  <CardBody>
                    {(() => {
                      switch (myview) {
                        case "personal-details":
                          return (
                            <>
                              
                              <Form>
                                <FormGroup row>
                                  <Col sm={4}>
                                    <TextField
                                      id="firstName"
                                      name="firstName"
                                      style={{ width: "100%" }}
                                      value={firstName}
                                      onChange={(e) =>
                                        setFirstname(e.target.value)
                                      }
                                      label="Enter Your First Name"
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <TextField
                                      id="middleName"
                                      name="middleName"
                                      style={{ width: "100%" }}
                                      value={middleName}
                                      onChange={(e) =>
                                        setMiddlename(e.target.value)
                                      }
                                      label="Enter Your Middle Name"
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <TextField
                                      id="lastName"
                                      name="lastName"
                                      style={{ width: "100%" }}
                                      value={lastName}
                                      onChange={(e) =>
                                        setLastname(e.target.value)
                                      }
                                      label="Enter Your Last Name"
                                    />
                                  </Col>
                                </FormGroup>
                                <FormGroup row>
                                  <Col sm={3}>
                                    Date of birth :{dateofbirth}
                                    <TextField
                                      id="date"
                                      type="date"
                                      name="dateofbirth"
                                      label="Date of Birth"
                                      // InputProps={{inputProps: dateofbirth}}
                                      variant="standard"
                                      style={{ width: "100%" }}
                                      // value={
                                      //   dateofbirth
                                      // }
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      onChange={(e) =>
                                        setDateofbirth(e.target.value)
                                      }
                                    />
                                  </Col>
                                  <Col sm={3}>
                                    <FormControl style={{ width: "100%" }}>
                                      <InputLabel id="demo-simple-select-label">
                                        Select Gender
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        name="gender"
                                        id="gender"
                                        value={gendertype}
                                        onChange={(e) =>
                                          setGender(e.target.value)
                                        }
                                      >
                                        {genderlist.map((option) => (
                                          <MenuItem value={option.gendertype}>
                                            {option.gendertype}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </Col>
                                  <Col sm={3}>
                                    <TextField
                                      style={{ width: "90%" }}
                                      name="mobileno"
                                      id="mobileno"
                                      onChange={(e) =>
                                        setMobileno(e.target.value)
                                      }
                                      value={mobileno}
                                      label="Enter Your  Mobile No"
                                    />
                                  </Col>
                                  <Col sm={3}>
                                    {learneremail === null ? (
                                      <TextField
                                        style={{ width: "90%" }}
                                        name="learneremail"
                                        id="learneremail"
                                        onChange={(e) =>
                                          setEmail(e.target.value)
                                        }
                                        placeholder="Enter Email Address"
                                      />
                                    ) : (
                                      <TextField
                                        style={{ width: "90%" }}
                                        name="learneremail"
                                        id="learneremail"
                                        value={learneremail}
                                        readOnly
                                      />
                                    )}
                                  </Col>
                                </FormGroup>
                                <FormGroup check row>
                                  <div className="col-lg-12 text-center">
                                    <div>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={loading}
                                        onClick={(e) => handlerSubmit1(e)}
                                      >
                                        Submit
                                      </Button>

                                      {loading === true ? (
                                        <CircularProgress
                                          size={24}
                                          color="green"
                                          className="buttonProgress1"
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                                <br />
                              </Form>
                            </>
                          );
                        case "educational-details":
                          return (
                            <>
                              <Form>
                                <FormGroup row>
                                  <Col sm={4}>
                                    <FormControl style={{ width: "100%" }}>
                                      <InputLabel id="demo-simple-select-label">
                                        Select Degree
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        name="degree"
                                        id="degree"
                                        // value={gendertype}
                                        onChange={(e) =>
                                          setDegree(e.target.value)
                                        }
                                      >
                                        {degreelist.map((option) => (
                                          <MenuItem value={option.degreename}>
                                            {option.degreename}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </Col>
                                  <Col sm={4}>
                                    <TextField
                                      id="qualificationname"
                                      name="qualificationname"
                                      style={{ width: "100%" }}
                                      value={qualificationname}
                                      onChange={(e) =>
                                        setQualificationname(e.target.value)
                                      }
                                      label="Enter Name Of Qualification"
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <TextField
                                      id="university"
                                      name="university"
                                      style={{ width: "100%" }}
                                      value={university}
                                      onChange={(e) =>
                                        setUniversity(e.target.value)
                                      }
                                      label="Enter University"
                                    />
                                  </Col>
                                </FormGroup>
                                <FormGroup row>
                                  <Col sm={4}>
                                    <TextField
                                      id="institute"
                                      name="institute"
                                      style={{ width: "100%" }}
                                      value={institute}
                                      onChange={(e) =>
                                        setInstitute(e.target.value)
                                      }
                                      label="Enter Institute"
                                    />
                                  </Col>

                                  <Col sm={4}>
                                    <TextField
                                      style={{ width: "90%" }}
                                      name="percentage"
                                      id="percentage"
                                      type="number"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      onChange={(e) =>
                                        setPercentage(e.target.value)
                                      }
                                      // value={mobileno}
                                      label="Enter Percentage/CPI"
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <FormControl style={{ width: "100%" }}>
                                      <InputLabel id="demo-simple-select-label">
                                        Select Class Obtain
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        name="grademark"
                                        id="grademark"
                                        // value={gendertype}
                                        onChange={(e) =>
                                          setGrademark(e.target.value)
                                        }
                                      >
                                        {gradelist.map((option) => (
                                          <MenuItem value={option.gradename}>
                                            {option.gradename}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </Col>
                                </FormGroup>

                                <FormGroup row>
                                  <Col sm={4}>
                                    <TextField
                                      style={{ width: "90%" }}
                                      name="passingyear"
                                      id="passingyear"
                                      type="number"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      onChange={(e) =>
                                        setPassingyear(e.target.value)
                                      }
                                      // value={mobileno}
                                      label="Enter Year Of Passing"
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <FormControl style={{ width: "100%" }}>
                                      <InputLabel id="demo-simple-select-label">
                                        Is Degree Completed ?
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        name="isdegreecompleted"
                                        id="isdegreecompleted"
                                        // value={gendertype}
                                        onChange={(e) =>
                                          setIsdegreecompleted(e.target.value)
                                        }
                                      >
                                        <MenuItem value="Yes">Yes</MenuItem>
                                        <MenuItem value="No">No</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Col>
                                  <Col sm={4}>
                                    <Label> Upload File</Label>
                                    <input
                                      id="contained-button-file"
                                      name="EduFilename"
                                      style={{ backgroundColor: "skyblue" }}
                                      multiple
                                      type="file"
                                      onChange={(e) =>
                                        setSelectedEduFile(e.target.files[0])
                                      }
                                    />
                                  </Col>
                                </FormGroup>

                                <FormGroup check row>
                                  <div className="col-lg-12 text-center">
                                    <div>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={loading}
                                        onClick={(e) => handlerSubmit3(e)}
                                      >
                                        Submit
                                      </Button>

                                      {loading === true ? (
                                        <CircularProgress
                                          size={24}
                                          color="green"
                                          className="buttonProgress1"
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                                <br />
                              </Form>
                              <Row>
                                <Col xs="10" sm="12" md="12">
                                  <span>
                                    <MaterialTable
                                      title=" Educational Details"
                                      columns={[
                                        { title: "Sr.No.", field: "srno" },
                                        {
                                          title: "Degree",
                                          field: "degreename",
                                        },

                                        {
                                          title: "Name Of Qalification",
                                          field: "nameofqualification",
                                        },

                                        {
                                          title: "Percentage/CPI",
                                          field: "cpimarks",
                                        },
                                        {
                                          title: "Class",
                                          field: "gradeclassname",
                                        },

                                        {
                                          title: "Is Degree Completed",
                                          field: "isdegreecompleted",
                                        },
                                        // {
                                        //   title: "Is Degree ",
                                        //   field: "academicsdocpath",
                                        // },
                                      ]}
                                      data={academicslist}
                                      actions={[
                                        {
                                          // icon: ReceiptIcon,
                                          icon: () => (
                                            <GetAppIcon color={"green"} />
                                          ),
                                          tooltip: "Download File",
                                          onClick: (event, rowData) =>
                                            openModaledu(
                                              event,
                                              rowData.academicsdocpath
                                            ),
                                        },

                                        {
                                          //icon: EditIcon ,
                                          icon: () => (
                                            <EditIcon color={"primary"} />
                                          ),
                                          tooltip: "Edit",

                                         onClick: (event, rowData) =>
                                         openModaledit(event, rowData.academicsid),
                                        },
                                        // {
                                        //   // icon: DeleteIcon,
                                        //   icon: () => <DeleteIcon color={"secondary"} />,
                                        //   tooltip: "Delete",
                                        //   onClick: (event, rowData) =>
                                        //     deleterecord(event, rowData.skid),
                                        // },
                                      ]}
                                      options={{
                                        exportButton: true,
                                        actionsColumnIndex: -1,
                                      }}
                                    />
                                  </span>
                                </Col>
                              </Row>
                              <Modal
                                isOpen={modalIsOpenedu}
                                onRequestClose={closeModaledu}
                                size="md"
                                // style={{height:"10px"}}
                                style={{
                                  top: "1%",
                                  bottom: "70%",
                                  height: "60px",
                                }}
                              >
                                <ModalHeader
                                  toggle={closeModaledu}
                                  className="header-modalc"
                                >
                                Download File
                                </ModalHeader>
                                <ModalBody>
                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                      {academicfile !== null ? (
                                        <>
                                          <MaterialComponent
                                            contentType="contenttype"
                                            contentId="0"
                                            materialid="0"
                                            materialtype={academicfile
                                              .split(".")
                                              .pop()}
                                            materialpath={academicfile}
                                          />
                                        </>
                                      ) : (
                                        <>No file Uploaded</>
                                      )}
                                    </Col>
                                  </Row>
                                </ModalBody>
                              </Modal>

                              <Modal
                                isOpen={modalIsOpenedit}
                                onRequestClose={closeModaledit}
                                size="md"
                                // style={{height:"10px"}}
                                style={{
                                  top: "1%",
                                  bottom: "70%",
                                  height: "60px",
                                }}
                              >
                                <ModalHeader
                                  toggle={closeModaledit}
                                  className="header-modalc"
                                >
                                   Edit  Educational Details
                                </ModalHeader>
                                <ModalBody>
                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                    <FormControl style={{ width: "100%" }}>
                                      <InputLabel id="demo-simple-select-label">
                                        Select Degree
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        name="degreenameedit"
                                        id="degreenameedit"
                                         value={degreenameedit}
                                        onChange={(e) =>
                                          setDegreenameedit(e.target.value)
                                        }
                                      >
                                        {degreelist.map((option) => (
                                          <MenuItem value={option.degreename}>
                                            {option.degreename}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                    </Col>
                                  </Row> 
                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                      <TextField
                                        id="nameofqualificationedit"
                                        name="nameofqualificationedit"
                                        style={{ width: "100%" }}
                                        value={nameofqualificationedit}
                                        onChange={(e) =>
                                          setNameofqualificationedit(
                                            e.target.value
                                          )
                                        }
                                        label="Enter Name Of Qualification "
                                      />
                                    </Col>
                                  </Row> 
                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                      <TextField
                                        id="universityedit"
                                        name="universityedit"
                                        style={{ width: "100%" }}
                                        value={universityedit}
                                        onChange={(e) =>
                                          setUniversityedit(e.target.value)
                                        }
                                        label="Enter University"
                                      />
                                    </Col>
                                  </Row> 
                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                      <TextField
                                        id="institutenameedit"
                                        name="institutenameedit"
                                        style={{ width: "100%" }}
                                        value={institutenameedit}
                                        onChange={(e) =>
                                          setInstitutenameedit(e.target.value)
                                        }
                                        label="Enter Institutename"
                                      />
                                    </Col>
                                  </Row> 
                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                  <TextField
                                      style={{ width: "90%" }}
                                      name="cpimarksedit"
                                      id="cpimarksedit"
                                      type="number"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      onChange={(e) =>
                                        setCpimarksedit(e.target.value)
                                      }
                                      value={cpimarksedit}
                                      label="Enter Percentage/CPI"
                                    />
  </Col>
                                  </Row> 
                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                    <FormControl style={{ width: "100%" }}>
                                      <InputLabel id="demo-simple-select-label">
                                        Select Class Obtain
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        name="gradeclassnameedit"
                                        id="gradeclassnameedit"
                                        value={gradeclassnameedit}
                                        onChange={(e) =>
                                          setGradeclassnameedit(e.target.value)
                                        }
                                      >
                                        {gradelist.map((option) => (
                                          <MenuItem value={option.gradename}>
                                            {option.gradename}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </Col>
                                  </Row> 
                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                    <TextField
                                      style={{ width: "90%" }}
                                      name="yearofpassingedit"
                                      id="yearofpassingedit"
                                      type="number"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      onChange={(e) =>
                                        setYearofpassingedit(e.target.value)
                                      }
                                       value={yearofpassingedit}
                                      label="Enter Year Of Passing"
                                    />
                                  </Col>
                                  </Row> 
                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                    <FormControl style={{ width: "100%" }}>
                                      <InputLabel id="demo-simple-select-label">
                                        Is Degree Completed ?
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        name="isdegreecompletededit"
                                        id="isdegreecompletededit"
                                         value={isdegreecompletededit}
                                        onChange={(e) =>
                                          setIsdegreecompletededit(e.target.value)
                                        }
                                      >
                                        <MenuItem value="Yes">Yes</MenuItem>
                                        <MenuItem value="No">No</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Col>
                                  </Row> 

                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                    <Label> Upload File</Label>
                                    
                                    <input
                                      id="contained-button-file"
                                      name="academicsdocpathedit"
                                      style={{ backgroundColor: "skyblue" }}
                                      multiple
                                      type="file"
                                      onChange={(e) =>
                                        setAcademicsdocpathedit(e.target.files[0])
                                      }
                                    />
                                  </Col>
                                  </Row>
                                  <br />

                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                    <div className="col-lg-12 text-center">
                                    <div>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={loading}
                                        onClick={(e) => handlerSubmiteditacadmic(e)}
                                      >
                                        Submit
                                      </Button>

                                      {loading === true ? (
                                        <CircularProgress
                                          size={24}
                                          color="green"
                                          className="buttonProgress1"
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>

                                    </Col>
                                  </Row>
                                 


                                </ModalBody>
                              </Modal>

                            </>
                          );
                        case "contact-details":
                          return (
                            <>
                              <Form>
                                <FormGroup row>
                                  <Col sm={4}>
                                    <TextField
                                      id="peraddress"
                                      name="peraddress"
                                      style={{ width: "100%" }}
                                      value={peraddress}
                                      rowsMax={3}
                                      onChange={(e) =>
                                        setPraddress(e.target.value)
                                      }
                                      label="Enter Permanent Address"
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <TextField
                                      id="perpin"
                                      name="perpin"
                                      style={{ width: "100%" }}
                                      value={perpin}
                                      onChange={(e) =>
                                        setPerpin(e.target.value)
                                      }
                                      label="Enter Permanent PinCode/Zip Code*"
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <FormControl style={{ width: "100%" }}>
                                      <InputLabel id="demo-simple-select-label">
                                        Select Permanent Country
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        name="percountryname"
                                        id="percountryname"
                                        value={percountryname}
                                        onChange={(e) =>
                                          setPercountryname(e.target.value)
                                        }
                                      >
                                        {countrylist.map((option) => (
                                          <MenuItem value={option.countryname}>
                                            {option.countryname}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </Col>
                                </FormGroup>
                                <Row>
                                  <Col sm={12}>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          name="issameaddress"
                                          checked={issameaddress}
                                          onChange={(e) =>
                                            setIssameaddress(!issameaddress)
                                          }
                                          color="primary"
                                        />
                                      }
                                      label="Whether Permanant Address is Same as Current Address ?"
                                    />
                                  </Col>
                                </Row>
                                <FormGroup row>
                                  {issameaddress === true ? (
                                    <>
                                      <Col sm={4}>
                                        <TextField
                                          id="localaddress"
                                          name="localaddress"
                                          style={{ width: "100%" }}
                                          value={peraddress}
                                          rowsMax={3}
                                          onChange={(e) =>
                                            setLocaladdress(e.target.value)
                                          }
                                          label="Enter Local Address"
                                        />
                                      </Col>
                                      <Col sm={4}>
                                        <TextField
                                          id="localpin"
                                          name="localpin"
                                          style={{ width: "100%" }}
                                          value={perpin}
                                          onChange={(e) =>
                                            setLocalpin(e.target.value)
                                          }
                                          label="Enter Local PinCode/Zip Code*"
                                        />
                                      </Col>
                                      <Col sm={4}>
                                        <FormControl style={{ width: "100%" }}>
                                          <InputLabel id="demo-simple-select-label">
                                            Select Local Country
                                          </InputLabel>
                                          <Select
                                            labelId="demo-simple-select-label"
                                            name="localcountryname"
                                            id="localcountryname"
                                            value={percountryname}
                                            onChange={(e) =>
                                              setLocalcountryname(
                                                e.target.value
                                              )
                                            }
                                          >
                                            {countrylist.map((option) => (
                                              <MenuItem
                                                value={option.countryname}
                                              >
                                                {option.countryname}
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl>
                                      </Col>
                                    </>
                                  ) : (
                                    <>
                                      <Col sm={4}>
                                        <TextField
                                          id="localaddress"
                                          name="localaddress"
                                          style={{ width: "100%" }}
                                          value={
                                            localaddress === null
                                              ? " "
                                              : localaddress
                                          }
                                          rowsMax={3}
                                          onChange={(e) =>
                                            setLocaladdress(e.target.value)
                                          }
                                          label="Enter Local Address"
                                        />
                                      </Col>
                                      <Col sm={4}>
                                        <TextField
                                          id="localpin"
                                          name="localpin"
                                          style={{ width: "100%" }}
                                          value={
                                            localpin === null ? " " : localpin
                                          }
                                          onChange={(e) =>
                                            setLocalpin(e.target.value)
                                          }
                                          label="Enter Local PinCode/Zip Code*"
                                        />
                                      </Col>
                                      <Col sm={4}>
                                        <FormControl style={{ width: "100%" }}>
                                          <InputLabel id="demo-simple-select-label">
                                            Select Local Country
                                          </InputLabel>
                                          <Select
                                            labelId="demo-simple-select-label"
                                            name="localcountryname"
                                            id="localcountryname"
                                            value={
                                              localpin === null
                                                ? " "
                                                : localcountryname
                                            }
                                            onChange={(e) =>
                                              setLocalcountryname(
                                                e.target.value
                                              )
                                            }
                                          >
                                            {countrylist.map((option) => (
                                              <MenuItem
                                                value={option.countryname}
                                              >
                                                {option.countryname}
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl>
                                      </Col>
                                    </>
                                  )}
                                </FormGroup>

                                <FormGroup row>
                                  <Col sm={4}>
                                    <TextField
                                      style={{ width: "90%" }}
                                      name="emergency_contact_name"
                                      id="emergency_contact_name"
                                      onChange={(e) =>
                                        setEmergencycontactname(e.target.value)
                                      }
                                      value={emergency_contact_name}
                                      label="Enter Emergency Contact Person Name"
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <TextField
                                      style={{ width: "190%" }}
                                      name="emergency_contact_number"
                                      id="emergency_contact_number"
                                      onChange={(e) =>
                                        setEmergencycontactnumber(
                                          e.target.value
                                        )
                                      }
                                      value={emergency_contact_number}
                                      label="Enter Emergency Contact Person Number"
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <TextField
                                      style={{ width: "100%" }}
                                      name="emergency_contact_email"
                                      id="emergency_contact_email"
                                      onChange={(e) =>
                                        setEmergencycontactemail(e.target.value)
                                      }
                                      value={emergency_contact_email}
                                      label="Enter Emergency Contact Person Email"
                                    />
                                  </Col>
                                </FormGroup>
                                <FormGroup check row>
                                  <div className="col-lg-12 text-center">
                                    <div>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={loading}
                                        onClick={(e) => handlerSubmit2(e)}
                                      >
                                        Submit
                                      </Button>

                                      {loading === true ? (
                                        <CircularProgress
                                          size={24}
                                          color="green"
                                          className="buttonProgress1"
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                                <br />
                              </Form>
                            </>
                          );
                        case "experience-details":
                          return (
                            <>
                              
                              <Form>
                                <FormGroup row>
                                  <Col sm={4}>
                                    <TextField
                                      id="organizationname"
                                      name="organizationname"
                                      style={{ width: "100%" }}
                                      onChange={(e) =>
                                        setOrganizationname(e.target.value)
                                      }
                                      label="Enter Organization Name"
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <TextField
                                      id="designation"
                                      name="designation"
                                      style={{ width: "100%" }}
                                      // value={middleName}
                                      onChange={(e) =>
                                        setDesignation(e.target.value)
                                      }
                                      label="Enter Designation"
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <TextField
                                      id="domain"
                                      name="domain"
                                      style={{ width: "100%" }}
                                      // value={lastName}
                                      onChange={(e) =>
                                        setDomain(e.target.value)
                                      }
                                      label="Enter Domain"
                                    />
                                  </Col>
                                </FormGroup>
                                <FormGroup row>
                                  <Col sm={4}>
                                    <TextField
                                      id="startdate"
                                      type="date"
                                      name="startdate"
                                      label="From Date"
                                      variant="standard"
                                      style={{ width: "100%" }}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      onChange={(e) =>
                                        setStartdate(e.target.value)
                                      }
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          name="iscurrentlyWorking"
                                          checked={iscurrentlyWorking}
                                          onChange={(e) =>
                                            setIscurrentlyWorking(
                                              !iscurrentlyWorking
                                            )
                                          }
                                          color="primary"
                                        />
                                      }
                                      label="Currently Working ?"
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    {iscurrentlyWorking === true ? (
                                      <></>
                                    ) : (
                                      <>
                                        <TextField
                                          id="endtdate"
                                          type="date"
                                          name="endtdate"
                                          label="To Date"
                                          variant="standard"
                                          style={{ width: "100%" }}
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          onChange={(e) =>
                                            setEndtdate(e.target.value)
                                          }
                                        />
                                      </>
                                    )}
                                  </Col>
                                </FormGroup>
                                <FormGroup check row>
                                  <div className="col-lg-12 text-center">
                                    <div>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={loading}
                                        onClick={(e) => handlerSubmit4(e)}
                                      >
                                        Submit
                                      </Button>

                                      {loading === true ? (
                                        <CircularProgress
                                          size={24}
                                          color="green"
                                          className="buttonProgress1"
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                                <br />
                              </Form>
                              <Row>
                                <Col xs="10" sm="12" md="12">
                                  <span>
                                    <MaterialTable
                                      title=" Experience Details"
                                      columns={[
                                        { title: "Sr.No.", field: "srno" },
                                        {
                                          title: "Organization Name",
                                          field: "organizationname",
                                        },

                                        {
                                          title: "Designation",
                                          field: "designation",
                                        },

                                        {
                                          title: "Domain",
                                          field: "domain",
                                        },
                                        {
                                          title: "Start date",
                                          field: "startdate",
                                        },
                                        {
                                          title: "End date",
                                          field: "enddate",
                                        },
                                        {
                                          title: "IsCurrentlyWorking",
                                          field: "iscurrentlyworking",
                                        },
                                        {
                                          title: "Years-Month",
                                          field: "noofyearsexp",
                                        },
                                      ]}
                                      data={experiencelist}
                                      actions={[
                                        {
                                          // icon: ReceiptIcon,
                                          icon: () => (
                                            <EditIcon color={"primary"} />
                                          ),
                                          tooltip: "Edit",

                                          onClick: (event, rowData) =>
                                            openModal(event, rowData.expid),
                                        },

                                        // {
                                        //   // icon: DeleteIcon,
                                        //   icon: () => <DeleteIcon color={"secondary"} />,
                                        //   tooltip: "Delete",
                                        //   onClick: (event, rowData) =>
                                        //     deleterecord(event, rowData.skid),
                                        // },
                                      ]}
                                      options={{
                                        exportButton: true,
                                        actionsColumnIndex: -1,
                                      }}
                                    />
                                  </span>
                                </Col>
                              </Row>
                              <Modal
                                isOpen={modalIsOpen}
                                onRequestClose={closeModal}
                                size="md"
                                // style={{height:"10px"}}
                                style={{
                                  top: "1%",
                                  bottom: "70%",
                                  height: "60px",
                                }}
                              >
                                <ModalHeader
                                  toggle={closeModal}
                                  className="header-modalc"
                                >
                                  {" "}
                                  Reciept{" "}
                                </ModalHeader>
                                <ModalBody>
                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                      <TextField
                                        id="organizationnameedit"
                                        name="organizationnameedit"
                                        style={{ width: "100%" }}
                                        value={organizationnameedit}
                                        onChange={(e) =>
                                          setOrganizationnameedit(
                                            e.target.value
                                          )
                                        }
                                        label="Enter Organization Name"
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                      <TextField
                                        id="designationedit"
                                        name="designationedit"
                                        style={{ width: "100%" }}
                                        value={designationedit}
                                        onChange={(e) =>
                                          setDesignationedit(e.target.value)
                                        }
                                        label="Enter Designation "
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                      <TextField
                                        id="domainedit"
                                        name="domainedit"
                                        style={{ width: "100%" }}
                                        value={domainedit}
                                        onChange={(e) =>
                                          setDomainedit(e.target.value)
                                        }
                                        label="Enter Domain "
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                      Current From Date - {startdateedit}
                                      <TextField
                                        id="startdateedit"
                                        type="date"
                                        name="startdateedit"
                                        label="From Date"
                                        variant="standard"
                                        style={{ width: "100%" }}
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        onChange={(e) =>
                                          setStartdateedit(e.target.value)
                                        }
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            name="iscurrentlyworkingedit"
                                            checked={iscurrentlyworkingedit}
                                            onChange={(e) =>
                                              setIscurrentlyworkingedit(
                                                !iscurrentlyworkingedit
                                              )
                                            }
                                            color="primary"
                                          />
                                        }
                                        label="Currently Working ?"
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                      {iscurrentlyworkingedit === true ? (
                                        <></>
                                      ) : (
                                        <>
                                          Current To Date - {enddateedit}
                                          <TextField
                                            id="enddateedit"
                                            type="date"
                                            name="enddateedit"
                                            label="To Date"
                                            variant="standard"
                                            style={{ width: "100%" }}
                                            InputLabelProps={{
                                              shrink: true,
                                            }}
                                            onChange={(e) =>
                                              setEnddateedit(e.target.value)
                                            }
                                          />
                                        </>
                                      )}
                                    </Col>
                                  </Row>
                                  <br />

                                  <Row>
                                    <Col xs="10" sm="12" md="12">
                                      <div className="col-lg-12 text-center">
                                        <div>
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={loading}
                                            onClick={(e) =>
                                              handlerSubmiteditexp(e)
                                            }
                                          >
                                            Submit
                                          </Button>

                                          {loading === true ? (
                                            <CircularProgress
                                              size={24}
                                              color="green"
                                              className="buttonProgress1"
                                            />
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </ModalBody>
                              </Modal>
                            </>
                          );
                        case "photo-upload":
                          return (
                            <>
                              <br />
                              <Form>
                                <FormGroup row>
                                  <Col sm={4}>
                                    <Container fixed>
                                      <Typography
                                        component="div"
                                        style={{
                                          backgroundColor: "orange",
                                          height: "auto",
                                          width: "90%",
                                          padding: "10px",
                                        }}
                                      >
                                        Photo Should be in .jpg format only.
                                        Photo Resolution should be W=350px.
                                        H=450px.Photo size should be less than
                                        or equal to 200 Kb.
                                      </Typography>
                                    </Container>
                                  </Col>
                                  <Col sm={4}>
                                    <Label> Upload File</Label>
                                    <input
                                      id="contained-button-file"
                                      style={{ backgroundColor: "skyblue" }}
                                      name="avtarFilename"
                                      multiple
                                      type="file"
                                      onChange={(e) =>
                                        setAvtarFilename(e.target.files[0])
                                      }
                                    />
                                    <br /> <br />
                                    <div className="col-lg-12 text-center">
                                      <div>
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          disabled={loading}
                                          onClick={(e) => handlerSubmit5(e)}
                                        >
                                          Upload
                                        </Button>

                                        {loading === true ? (
                                          <CircularProgress
                                            size={24}
                                            color="green"
                                            className="buttonProgress1"
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </Col>
                                  <Col sm={4}>
                                    {peravtarpath !== null ? (
                                      <>
                                        <Label style={{ marginLeft: "60px" }}>
                                          Photo
                                        </Label>
                                        <br />
                                        <div>
                                          <img
                                            // sm={12}

                                            style={{
                                              width: "150px",
                                              height: "170px",
                                              // border: "1px solid #CCC",
                                              marginLeft: "60px",
                                            }}
                                            id="blah"
                                            src={peravtarpath}
                                            alt=""
                                          />
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </Col>
                                </FormGroup>

                                <br />
                              </Form>
                            </>
                          );

                        default:
                          return <> </>;
                      }
                    })()}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Uploaddocument;
